import {
  login,
  logout,
  isUserLogged,
  getUserInfo
} from '../../api/auth'

import { getToken, setToken, removeToken } from '../../utils'
import { resetRouter } from '../../router'

const state = {
  token: getToken(),
  user: {}
}

const mutations = {
  SET_TOKEN: (state, token) => {
    state.token = token
  },
  SET_USER: (state, user) => {
    state.user = user
  }
}

const actions = {
  // user login
  login ({ commit, dispatch }, userInfo) {
    const { username, password } = userInfo
    return new Promise((resolve, reject) => {
      login(username.trim(), password).then(response => {
        const { user } = response
        commit('SET_TOKEN', user.uid)
        setToken(user.uid)
        dispatch('getUserInfo')
        resolve(user)
      }).catch(error => {
        reject(error)
      })
    })
  },
  async isUserLogged () {
    const isLogged = await isUserLogged()
    return isLogged
  },
  async getUserInfo ({ commit, dispatch }) {
    const isLogged = await dispatch('isUserLogged')
    return !isLogged ? {} : new Promise((resolve, reject) => {
      getUserInfo(state.token).then((doc) => {
        commit('SET_USER', doc.data())
        resolve()
      }).catch((err) => {
        console.error(err)
        reject(err)
      })
    })
  },
  // user logout
  logout ({ commit, state }) {
    return new Promise((resolve, reject) => {
      logout(state.token).then(() => {
        commit('SET_TOKEN', '')
        commit('SET_USER', {})
        removeToken()
        resetRouter()
        resolve()
      }).catch(error => {
        reject(error)
      })
    })
  },

  // remove token
  resetToken ({ commit }) {
    return new Promise(resolve => {
      commit('SET_TOKEN', '')
      removeToken()
      resolve()
    })
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}
